export class NoEditHierarchyRightError {}
export class NoManageUsersRightError {}
export class NoRightsError {}
export class NoSubmitTTRightError {}
export class NoAccessToScopeError {}
export class NotFoundError {}
export class NoSuchUserError {}
export class NotAssignedError {}
export class EditingUserDisabled {}
export class NoSuchUserGroupError {}
export class SelectedUserDeletedError {}



// WEBPACK FOOTER //
// ./web/js/panels/errors.js